import { createFileRoute } from '@tanstack/react-router';

import { DealIntelligencePage } from '@/features/deal-intelligence/components/DealIntelligencePage';
import { PlatformRestriction } from '@/shared/navigation/components/PlatformRestriction';

/**
 * `lastGap` carries the gap the reader just came back from. It lives in the
 * URL rather than component state so the restored scroll position and the
 * highlight survive a reload.
 */
export interface DealIntelligenceSearch {
  lastGap?: string;
}

export const Route = createFileRoute('/_dashboard/deal-intelligence')({
  validateSearch: (
    search: Record<string, unknown>
  ): DealIntelligenceSearch => ({
    lastGap: typeof search.lastGap === 'string' ? search.lastGap : undefined,
  }),
  component: AllGapsRoute,
});

function AllGapsRoute() {
  const { lastGap } = Route.useSearch();
  return (
    <PlatformRestriction notAllowedPlatforms={['mobile']}>
      <DealIntelligencePage lastViewedGapId={lastGap} />
    </PlatformRestriction>
  );
}
